import React from "react";
import { FaMoneyBillWave, FaExchangeAlt, FaRedoAlt } from "react-icons/fa";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";

export function ProductsCredt({
    setTypeProductSelected,
    typeProductSelected,
    typeProducts,
    onGoToRegister
}) {
    return (
        <div id="ProductsCredt" className="bg-gray-100 py-12 px-4 md:px-12 text-gray-800">
            <div className="max-w-7xl mx-auto">

                {/* Título */}
                <h2 className="text-3xl md:text-4xl font-bold text-center">
                    Seu crédito seguro e personalizado
                </h2>
                <p className="text-center mt-2 text-sm md:text-base text-gray-600">
                    Escolha a opção que melhor atende aos seus objetivos e alcance sua liberdade financeira:
                </p>

                {/* Filtros */}
                <div className="flex flex-wrap justify-center gap-2 mt-6">
                    {["INSS", "FGTS", "Seguros"].map((filter, i) => (
                        <button
                            onClick={e => setTypeProductSelected(filter.toUpperCase())}
                            key={i}
                            className={`px-4 py-1.5 text-sm rounded-full border ${filter.toUpperCase() === typeProductSelected
                                ? "bg-[#FA6300] text-white border-[#FA6300]"
                                : "border-gray-300 text-gray-600 hover:border-[#FA6300] hover:text-[#FA6300]"
                                } transition`}
                        >
                            {filter}
                        </button>
                    ))}
                </div>

                {/* Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
                    {typeProducts.filter(x => x.tag === typeProductSelected).map(product => (
                        <CardCredito
                            onGoToRegister={onGoToRegister}
                            title={product.title}
                            description={product.description}
                            icon={<product.icon />}
                            tag={product.tag}
                            bullets={product.bullets}
                            action={product.action}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

/* CARD COMPONENTE */
function CardCredito({ onGoToRegister,icon, title, description, tag, bullets, action }) {
    return (
        <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition flex flex-col justify-between h-full">
            {/* TAG */}
            <div className="mb-4">
                <span className="text-xs font-bold bg-[#FA6300]/10 text-[#FA6300] px-2 py-0.5 rounded-full">
                    {tag}
                </span>
            </div>

            {/* Ícone e título */}
            <div className="flex items-start gap-3">
                <div className="text-[#FA6300] text-xl">{icon}</div>
                <div>
                    <h3 className="font-semibold text-base">{title}</h3>
                    <p className="text-sm text-gray-600 mt-1">{description}</p>
                </div>
            </div>

            {/* Lista de vantagens */}
            <ul className="mt-4 space-y-1 text-sm text-gray-700">
                {bullets.map((item, i) => (
                    <li key={i} className="flex items-center gap-2">
                        <span className="text-[#FA6300] font-bold">✓</span> {item}
                    </li>
                ))}
            </ul>

            {/* Botão de ação */}
            <button onClick={onGoToRegister} className="mt-6 bg-[#FA6300] hover:bg-[#d45400] text-white text-sm font-bold py-2 rounded-full w-full transition">
                {action}
            </button>
        </div>
    );
}
